import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { format, parseISO } from 'date-fns';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TablePagination, TextField } from '@mui/material';
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { FiAlertTriangle } from "react-icons/fi";

export default function OfcBearer() {

    const lottiee = require('../images/lottiee.json');
    const loading = require('../images/loading.json');
    
    const [smShow, setSmShow] = useState(false);
    const [show, setShow] = useState(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [bearerData, setbearerData] = useState([]);
    const [OfficeBearer_Name, setOfficeBearer_Name] = useState('');
    const [OfficeBearer_Designation, setOfficeBearer_Designation] = useState('');
    const [OfficeBearer_Profile, setOfficeBearer_Profile] = useState('');
    const [updateOfcData, setupdateOfcData] = useState({});
    const [loader, setloader] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");

    const filteredData = bearerData.filter((item) => {
        return (
          item.OfficeBearer_Name.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.OfficeBearer_Designation.toLowerCase().includes(searchQuery.toLowerCase()) ||
          item.OfficeBearer_Profile.toLowerCase().includes(searchQuery.toLowerCase())
        );
      });

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setPage(0);
    };

    const officeBearer = ()=>{
        setloader(true)
        const requestOptions = {
          method: "GET",
          redirect: "follow"
        };
        
        fetch("https://api.padampura.com/Committee_OfficeList", requestOptions)
         .then((response) => response.json())
          .then((result) => {
            if(result.status === true){
            //   console.log(result.data.OfficeBearers)
              setbearerData(result.data.OfficeBearers)
            setloader(false)
            }
          })
          .catch((error) => console.error(error))
          .finally(()=> setloader(false))
      }

      const insertOfcBearer = ()=>{
        if (!OfficeBearer_Name) {
            alert("Please enter OfficeBearer_Name");
            return;
        }
        const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "OfficeBearer_Name": OfficeBearer_Name,
                "OfficeBearer_Designation": OfficeBearer_Designation,
                "OfficeBearer_Profile": OfficeBearer_Profile,
                // "OfficeBearer_ImagePath": "",
                // "OfficeBearer_ImageStream": ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch("https://api.padampura.com/Committee_Office_Insert", requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result)
                     alert("Insert Successfully");
                     officeBearer();
                 }else{
                     alert("Try Again !!")
                 }
             })
             .catch((error) => console.error(error));
      }

      const handleChangeUpdtOfcBearer = (e) => {
        const { name, value, type, checked } = e.target;
        setupdateOfcData({
          ...updateOfcData,
          [name]: type === "checkbox" ? checked : value,
        });
      };

      const handleClear = ()=>{
        setOfficeBearer_Name('');
        setOfficeBearer_Designation('');
        setOfficeBearer_Profile('');
      }

      const updateBearer = ()=>{
        const myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                ...updateOfcData
            // "OfficeBearer_Name": "Testing 2",
            // "OfficeBearer_Designation": "Accounts",
            // "OfficeBearer_Profile": "Info",
            // "OfficeBearer_ImagePath": "",
            // "OfficeBearer_ImageStream": ""
            });

            const requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            fetch(`https://api.padampura.com/Committee_Office_Update?MainID=${updateOfcData.OfficeBearer_ID}`, requestOptions)
            .then((response) => response.json())
             .then((result) => {
                 if(result.status === true){
                     // console.log(result)
                     alert("Update Successfully");
                     officeBearer();
                 }else{
                     alert("Try Again !!");
                 }
             })
             .catch((error) => console.error(error));
      }

      const deleteBearer = ()=>{
        const requestOptions = {
            method: "DELETE",
            redirect: "follow"
          };
          
          fetch(`https://api.padampura.com/Committee_Office_Delete?MainID=${updateOfcData.OfficeBearer_ID}`, requestOptions)
           .then((response) => response.json())
            .then((result) => {
                if(result.status === true){
                    // console.log(result)
                    alert("Delete Successfully");
                    officeBearer();
                }else{
                    alert("Try Again !!");
                }
            })
            .catch((error) => console.error(error));
      }

      useEffect(()=>{
        officeBearer();
      },[])

    return (
        <>
            <div className='container-fluid p-0'>
                <div className='row g-0'>
                    <div className='col-2 side'>
                        <Sidebar />
                    </div>
                    <div className='col-10 side2'>
                        <Header />
                        <div className='scroll-box'>
                            <div className="container-fluid">
                                <div className='row d-flex justify-content-between mt-2'>
                                  <div className='col-4' style={{ fontFamily: "Poppins", fontWeight: 600, fontSize: "1.2em", }} >Office Bearer</div>
                                    <div className='col-4'>
                                       <TextField
                                           label="Search Office Bearer"
                                           value={searchQuery}
                                           onChange={(e) => setSearchQuery(e.target.value)}
                                           variant="outlined"
                                           size="small"
                                           fullWidth
                                           sx={{ mb: 0 }}
                                        />
                                    </div>
                                  <div onClick={handleShow} className='col-2 d-flex justify-content-center align-items-center p-1 rounded-1' style={{ backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>+ Add</div>
                                </div>
                                <div className="row mt-2">
                                    <div className="col-12 m-auto">
                                        <div className='card-list-box-sr card p-2 border-0'>
                                            <div className="table-responsive">
                                                <Paper sx={{ width: '100%' }}>
                                                    <TableContainer sx={{ mt: -1 }}>
                                                        <Table stickyHeader aria-label="sticky table" size="small">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Name</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Designation</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Profile</TableCell>
                                                                    <TableCell sx={{ fontWeight: "600", minWidth: 50, fontFamily: "Poppins" }}>Action</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {
                                                                    loader?(
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                                <div style={{ fontFamily:"Poppins", fontSize:16 }} >Loading...</div>
                                                                                <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={loading}
                                                                                    style={{ height: '200px', width: '200px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                            </Player>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ):filteredData.length === 0 ? (
                                                                        <TableRow>
                                                                            <TableCell colSpan={4} align="center">
                                                                             <Player
                                                                                    autoplay
                                                                                    loop
                                                                                    src={lottiee}
                                                                                    style={{ height: '100px', width: '100px' }}
                                                                                >
                                                                                <Controls visible={false} buttons={['play', 'repeat', ]} />
                                                                             </Player>
                                                                             <div style={{ fontFamily:"Poppins", fontSize:16, color:'red' }} >Data Not Present...</div>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )
                                                                    :(
                                                                        filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
                                                                            <TableRow key={index}>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.OfficeBearer_Name}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.OfficeBearer_Designation}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", fontSize: "12px" }}>{item.OfficeBearer_Profile}</TableCell>
                                                                                <TableCell sx={{ fontWeight: "500", minWidth: 50, fontFamily: "Poppins", }}>
                                                                                   <div className='d-flex justify-content-between' style={{ width:50, }}>
                                                                                     <FaEdit onClick={() => {handleShow2();setupdateOfcData({...item})}} style={{ cursor: "pointer", color:"#566573" }} />
                                                                                     <MdDelete onClick={()=> {setSmShow(true);setupdateOfcData({...item})}} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                                                   </div>
                                                                                </TableCell>
                                                                             </TableRow>
                                                                        ))
                                                                    )
                                                                }
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                    <TablePagination
                                                        rowsPerPageOptions={[5, 10, 20]}
                                                        component="div"
                                                        count={bearerData.length}
                                                        rowsPerPage={rowsPerPage}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </Paper>
                                                <Modal show={show} onHide={handleClose} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Add Office Bearer</Modal.Title>
                                                    </Modal.Header>
                                                     <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Name</div>
                                                                <input className='sercc-inpt p-1' value={OfficeBearer_Name} onChange={(e)=> setOfficeBearer_Name(e.target.value)} placeholder="Name" autoFocus required style={{width:"100%"}} />
                                                            </div>
                                                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Designation</div>
                                                                <input className='sercc-inpt p-1' value={OfficeBearer_Designation} onChange={(e)=> setOfficeBearer_Designation(e.target.value)} placeholder="Designation" autoFocus required style={{width:"100%"}} />
                                                            </div>
                                                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Designation</div>
                                                                <input className='sercc-inpt p-1' value={OfficeBearer_Profile} onChange={(e)=> setOfficeBearer_Profile(e.target.value)} placeholder="Profile" autoFocus required style={{width:"100%"}} />
                                                            </div>
                                                            </div>
                                                            <div className='row mt-3'>
                                                              <div className='col-2 m-auto'>
                                                                <div onClick={()=> {insertOfcBearer(); handleClose();handleClear()}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Save</div>
                                                              </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                                <Modal show={show2} onHide={handleClose2} size="lg" aria-labelledby="example-modal-sizes-title-lg">
                                                    <Modal.Header closeButton>
                                                       <Modal.Title>Office Bearer</Modal.Title>
                                                    </Modal.Header>
                                                     <Modal.Body>
                                                        <div className='container-fluid'>
                                                            <div className='row'>
                                                             <div className='col-lg-4 col-md-12 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Name</div>
                                                                <input className='sercc-inpt p-1' name='OfficeBearer_Name' value={updateOfcData.OfficeBearer_Name} onChange={handleChangeUpdtOfcBearer} placeholder="Name" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                             <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Designation</div>
                                                                <input className='sercc-inpt p-1' name='OfficeBearer_Designation' value={updateOfcData.OfficeBearer_Designation} onChange={handleChangeUpdtOfcBearer} placeholder="Designation" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                             <div className='col-lg-4 col-md-6 col-sm-12'>
                                                                <div className='' style={{ fontFamily:'Poppins', fontSize:"13px", color:'#1f5156', fontWeight:600 }}>Designation</div>
                                                                <input className='sercc-inpt p-1' name='OfficeBearer_Profile' value={updateOfcData.OfficeBearer_Profile} onChange={handleChangeUpdtOfcBearer} placeholder="Profile" autoFocus required style={{width:"100%"}} />
                                                             </div>
                                                            </div>
                                                            <div className='row mt-2'>
                                                              <div className='col-2 m-auto'>
                                                                <div onClick={()=> {updateBearer();handleClose2()}} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width:'100%', backgroundColor:"#2C3E50", fontFamily:"Poppins", fontWeight:400, color:"#fff", cursor:"pointer" }}>Update</div>
                                                              </div>
                                                            </div>
                                                        </div>
                                                    </Modal.Body>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                size="sm"
                show={smShow}
                onHide={() => setSmShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-sm">
                        <FiAlertTriangle style={{ color: "orangered" }} />
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center align-items-center" style={{ fontFamily: 'Poppins', fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>Are you sure want to Delete ??</div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={()=> {setSmShow(false);deleteBearer()}} className='d-flex justify-content-center align-items-center p-1 rounded-1 me-2' style={{ width: '100%', backgroundColor: "#239B56", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>Yes</div>
                        <div onClick={()=> setSmShow(false)} className='d-flex justify-content-center align-items-center p-1 rounded-1' style={{ width: '100%', backgroundColor: "#E74C3C", fontFamily: "Poppins", fontWeight: 400, color: "#fff", cursor: "pointer" }}>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
